import {
  HUBSPOT_API_ENDPOINTS,
  HUBSPOT_DEFAULT_CONFIG,
  HUBSPOT_API_BASE_URL,
} from "@stadium/services/hubspot/constants";
import { getInstance } from "@stadium/services/axios";
import { SentryError } from "@stadium/services/error-reporting/utils";

export const axiosInstance = getInstance({ baseURL: HUBSPOT_API_BASE_URL });

const { post } = axiosInstance;

class HubspotFormDataSubmissionError extends SentryError {
  get name() {
    return "Hubspot form data submission error";
  }
}

export const getHubspotSubmissionErrorResponse = (error) => {
  const { response } = error ?? {};
  if (!response) return null;

  return {
    status: response.status,
    data: response.data,
  };
};

export const submitHubspotFormDataAPI = async (formGuid, params) => {
  try {
    const response = await post(
      HUBSPOT_API_ENDPOINTS.submitFormData
        .replace(":portalId", HUBSPOT_DEFAULT_CONFIG.portalId)
        .replace(":formGuid", formGuid),
      params,
    );
    return response;
  } catch (error) {
    throw new HubspotFormDataSubmissionError(error, {
      data: { payload: params, errorResponse: getHubspotSubmissionErrorResponse(error) },
    });
  }
};
